import React, { useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExportButton from "components/button/ExportButton";
import ButtonComponent from "components/button/ButtonComponent";
import useLoadMore from "hooks/useLoadMore";
import { getUserType } from "util/auth";
import QuotationsTable from "../components/QuotationsTable";
import SearchContainer from "../components/SearchContainer";
import useQuotationList from "../hooks/useQuotationList";

/**
 * 見積一覧
 * @returns JSX.Element
 */
export default function QuotationList() {
  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const userType = getUserType();

  const handleClick = () => {
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      fileInputRef.current?.click();
    } else {
      alert("この機能はモバイルデバイスでのみ利用可能です。");
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {};

  const {
    queryParams,
    loading,
    total,
    handleSearch,
    setQueryParams,
    onLoadMore,
    quotations,
    quoteByList,
  } = useQuotationList();
  const { renderNodeLoader } = useLoadMore(onLoadMore, loading);

  return (
    <>
      <Box
        sx={{
          px: { xs: 2, md: 2.5, lg: 5 },
          pt: { xs: 2, md: 2.5, lg: 3 },
          backgroundColor: "var(--white)",
        }}
      >
        <Button onClick={() => navigate("/")} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: { sm: "block", md: "flex" },
          p: { xs: 2, md: 2.5, lg: 5 },
          backgroundColor: "var(--white)",
          gap: 5,
        }}
      >
        <Box
          sx={{
            display: { sm: "flex", md: "block", minWidth: "180px" },
            justifyContent: "space-between",
            mb: { xs: 3, md: 0 },
          }}
        >
          <Typography
            fontSize={29}
            variant="h2"
            sx={{
              marginBottom: { xs: "10px", md: "27px" },
              color: "var(--gray-700)",
              fontWeight: "medium",
            }}
          >
            見積一覧
          </Typography>
          {userType !== "C0001" && (
            <ExportButton label="新規見積" onClick={() => navigate("/new-quote")} />
          )}
        </Box>
        <Box sx={{ marginX: { sm: 0, xl: "115px" } }}>
          <SearchContainer
            params={queryParams}
            setParams={setQueryParams}
            quoteByList={quoteByList}
          />
          <Box sx={{ display: "flex", mb: { xs: 3, md: 7 }, mt: 8 }}>
            <ButtonComponent
              theme="dark"
              label="QRコードを読む"
              sx={{ width: "258px", fontSize: "25px" }}
              onClick={handleClick}
            />
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              capture="environment"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <Box sx={{ display: "flex", justifyContent: "center", width: "calc(100% - 258px)" }}>
              <ButtonComponent
                onClick={handleSearch}
                theme="dark"
                label="検索"
                sx={{ width: "225px", marginX: "auto", fontSize: "25px" }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          px: { xs: 2, md: 2.5, lg: 5 },
          display: "flex",
          backgroundColor: "var(--offwhite-100)",
          py: 3,
          justifyContent: "center",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Box
              sx={{
                textAlign: "right",
                marginBottom: "11px",
                fontSize: { xs: 16, md: 18, lg: 20 },
                color: "var(--black)",
                fontWeight: "regular",
              }}
            >
              検索件数【{total}件】
            </Box>
          </Box>
          <Box sx={{ overflowX: "auto", width: "100%" }}>
            <QuotationsTable quoList={quotations} queryParams={queryParams} />
            {renderNodeLoader()}
          </Box>
        </Box>
        {/* <Box display="flex" flexDirection="row" justifyContent="space-between">
          <CustomTextField
            id="quonum"
            type="text"
            label="見積番号"
            text={quotationNum}
            setText={setQuotationNum}
            maxLength={100}
            size="small"
          />
          <CustomTextField
            id="name"
            type="text"
            label="氏名"
            text={customerName}
            setText={setCustomerName}
            maxLength={100}
            size="small"
          />
          <CustomTextField
            id="tel"
            type="text"
            label="電話番号"
            text={tel}
            setText={setTel}
            maxLength={100}
            size="small"
          />
          <Box>
            <Button
              variant="contained"
              sx={{ backgroundColor: "gray", color: "var(--white)" }}
              onClick={onSearchClick}
            >
              検索
            </Button>
          </Box>
        </Box> */}
      </Box>
    </>
  );
}
